import { render, staticRenderFns } from "./TranslationPluralizationInputGroup.vue?vue&type=template&id=5c93d12b&scoped=true&"
import script from "./TranslationPluralizationInputGroup.vue?vue&type=script&lang=js&"
export * from "./TranslationPluralizationInputGroup.vue?vue&type=script&lang=js&"
import style0 from "./TranslationPluralizationInputGroup.vue?vue&type=style&index=0&id=5c93d12b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c93d12b",
  null
  
)

export default component.exports